import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import SmallSearchIcon from 'Common/assets/icons/smallSearch.svg';
import { MemoizedSearchBoxSmall } from '../SearchBox';
const SearchGeneBox = (props) => (_jsx(MemoizedSearchBoxSmall, Object.assign({ searchIcon: SmallSearchIcon }, props), void 0));
export default memo(SearchGeneBox);
